const PACKING_LIST_UNAVAILABLE_ERRORS = [
  'User not authenticated',
  'Packing list not found',
];

export function isPackingListUnavailableError(error: string): boolean {
  return PACKING_LIST_UNAVAILABLE_ERRORS.includes(error);
}
